"use client";

import { useMemo } from "react";
import type { AppJournalEntry } from "@/vybe-trader-client/messaging/stores/useJournalStore";
import {
  getEntryType,
  journalEntrySearchHaystack,
} from "./journalEntryUtils";

export function filterJournalEntries(
  entries: AppJournalEntry[],
  searchQuery: string,
  selectedTypes: string[]
): AppJournalEntry[] {
  let filtered = entries;

  if (searchQuery) {
    const q = searchQuery.toLowerCase();
    filtered = filtered.filter((entry) =>
      journalEntrySearchHaystack(entry).includes(q)
    );
  }

  if (selectedTypes.length > 0) {
    filtered = filtered.filter((entry) =>
      selectedTypes.includes(getEntryType(entry))
    );
  }

  return [...filtered].sort((a, b) => a.timestamp - b.timestamp);
}

export function useJournalFilteredEntries(
  entries: AppJournalEntry[],
  searchQuery: string,
  selectedTypes: string[]
): AppJournalEntry[] {
  return useMemo(
    () => filterJournalEntries(entries, searchQuery, selectedTypes),
    [entries, searchQuery, selectedTypes]
  );
}

export function useJournalMessageTypes(
  entries: AppJournalEntry[]
): string[] {
  return useMemo(() => {
    const types = new Set<string>();
    entries.forEach((entry) => {
      types.add(getEntryType(entry));
    });
    return Array.from(types).sort((a, b) => a.localeCompare(b));
  }, [entries]);
}
